import React from 'react';
import { SubmittedTab } from '../academic-affair-program-requests/components/program-requests-submittedTab';
import { ReviewTab } from '../academic-affair-program-requests/components/program-requests-reviewTab';
import { ApprovedTab } from '../academic-affair-program-requests/components/program-requests-approvedTab';
import { DeniedTab } from '../academic-affair-program-requests/components/program-requests-deniedTab';
import { AwaitingResponseTab, ProgramRequestsInstitutionViewTab } from "../academic-affair-program-requests/components";
/*
each tab has its own id. that id is used here for master tab lists. will show the required tab based on id passed in
this page will be used for all tabs on the site
 */
export const TabsMaster = ({ activeTab, tabData }) => {

    return (
        <div className="tab-content">
            {activeTab === 'submitted' && (
                <SubmittedTab data={tabData[activeTab]} />
            )}
            {activeTab === 'review' && (
                <ReviewTab data={tabData[activeTab]} />
            )}
            {activeTab === 'approved' && (
                <ApprovedTab data={tabData[activeTab]} />
            )}
            {activeTab === 'denied' && (
                <DeniedTab data={tabData[activeTab]} />
            )}
            {activeTab === 'programRequests' && (
                <ProgramRequestsInstitutionViewTab data={tabData[activeTab]} />
            )}
            {activeTab === 'awaitingResponse' && (
              <AwaitingResponseTab data={tabData[activeTab]} />
            )}
        </div>
    );
};
